export function pluralize(n: number, singular: string, plural: string): string {
  return n > 1 ? `${n} ${plural}` : `${n} ${singular}`;
}

export function formatLevel(level: LevelName) {
  return levelLabels[level];
}

export function formatWorkshop(workshop: WorkshopName) {
  return workshopLabels[workshop];
}
